// extracted by mini-css-extract-plugin
module.exports = {"avatarImgWrapper":"Avatar-module--avatarImgWrapper--34yEC"};